import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  FormText,
  Card,
  Table,
} from "react-bootstrap";
import { API_ENDPOINTS, handleKeyDown, TERMS } from "../../constant/_constant";
import {
  IconFileDescription,
  IconLabel,
  IconArticle,
  IconUser,
  IconMail,
  IconPhone,
  IconTruck,
  IconFileText,
  IconReceipt,
  IconHomeSpark,
  IconCalendarWeek,
  IconCurrencyDollar,
} from "@tabler/icons-react";
import { useFormContext, Controller } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import useDebounce from "../../hooks/useDebounce";
import usePostRequest from "../../hooks/usePostRequest";
import DatePicker from "react-datepicker";

function BillingAndShippingForm({ initialVal }) {
  const {
    control,
    watch,
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();

  const [searchDebounce, setSearchDebounce] = useState({
    searchName: "",
    searchEmail: "",
  });

  const suppressAutoUpdate = useRef(false);
  const { debounceSearch } = useDebounce();
  const [suggestion, setSuggestion] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const sameShipNameasKO = watch("sameShipNameasKO");
  // const initial_consolidation = watch("initial_consolidation");
  const sameBillNameasKO = watch("sameBillNameasKO");
  const contractOfficerName = watch("contractOfficerName");
  const contractOfficerEmail = watch("contractOfficerEmail");
  const contractOfficerAddress = watch("contractOfficerAddress");
  const contractOfficerPhone = watch("contractOfficerPhone");
  const selectedBySuggestion = watch("selectedBySuggestion");

  const handleSameAsKO = (type, isChecked) => {
    const koFields = {
      name: getValues("contractOfficerName") || "",
      email: getValues("contractOfficerEmail") || "",
      phone: getValues("contractOfficerPhone") || "",
      address: getValues("contractOfficerAddress") || "",
    };

    if (type === "shipping") {
      // if (isChecked) {
      setValue("shippingCustomerName", koFields.name);
      setValue("shippingCustomerEmail", koFields.email);
      setValue("shippingCustomerPhone", koFields.phone);
      setValue("shippingCustomerAddress", koFields.address);
      // } else {
      //   setValue("shippingCustomerName", "");
      //   setValue("shippingCustomerEmail", "");
      //   setValue("shippingCustomerPhone", "");
      //   setValue("shippingCustomerAddress", "");
      // }
    } else if (type === "billing") {
      // if (isChecked) {
      setValue("BillingCustomerName", koFields.name);
      setValue("BillingCustomerEmail", koFields.email);
      setValue("BillingCustomerPhone", koFields.phone);
      setValue("BillingCustomerAddress", koFields.address);
      // } else {
      //   setValue("BillingCustomerName", "");
      //   setValue("BillingCustomerEmail", "");
      //   setValue("BillingCustomerPhone", "");
      //   setValue("BillingCustomerAddress", "");
      // }
    }
  };

  // useEffect(() => {
  //   const updateShippingDetails = () => {
  //     if (sameShipNameasKO === true) {
  //       console.log("fill values for shipping");
  //       setValue("shippingCustomerName", contractOfficerName);
  //       setValue("shippingCustomerAddress", contractOfficerAddress);
  //       setValue("shippingCustomerEmail", contractOfficerEmail);
  //       setValue("shippingCustomerPhone", contractOfficerPhone);
  //     } else if (initialVal === 0 && sameShipNameasKO === false) {
  //       console.log("empty values for shipping");
  //       setValue("shippingCustomerName", "");
  //       setValue("shippingCustomerAddress", "");
  //       setValue("shippingCustomerEmail", "");
  //       setValue("shippingCustomerPhone", "");
  //     }
  //   };
  //   updateShippingDetails();
  // }, [
  //   sameShipNameasKO,
  //   setValue,
  // ]);

  // useEffect(() => {
  //   const updateBillingDetails = () => {
  //     if (sameBillNameasKO === true) {
  //       console.log("fill values for billing");
  //       setValue("BillingCustomerName", contractOfficerName);
  //       setValue("BillingCustomerAddress", contractOfficerAddress);
  //       setValue("BillingCustomerEmail", contractOfficerEmail);
  //       setValue("BillingCustomerPhone", contractOfficerPhone);
  //     } else if (initialVal === 0 && sameBillNameasKO === false) {
  //       // console.log("empty values for billing");
  //       setValue("BillingCustomerName", "");
  //       setValue("BillingCustomerAddress", "");
  //       setValue("BillingCustomerEmail", "");
  //       setValue("BillingCustomerPhone", "");
  //     }
  //   };

  //   updateBillingDetails();
  // }, [sameBillNameasKO, setValue]);

  const textareaRef = useRef(null);
  const address = watch("shippingCustomerAddress");
  const BillingAddress = watch("BillingCustomerAddress");

  const OrderType = watch("ordertype");

  const handleResize = (textarea) => {
    // console.log("textarea", textarea);
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  const {
    data: fetchdata,
    isLoading,
    postData: fetchRfq,
  } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_AUTOFILL);

  const prependCountryCodeIfMissing = (phoneNumber) => {
    if (!phoneNumber) return phoneNumber;
    const trimmed = phoneNumber.trim();
    if (trimmed.startsWith("+")) {
      return trimmed;
    }
    return "+1" + trimmed;
  };

  const handleSelect = (item) => {
    suppressAutoUpdate.current = true;

    setValue("selectedBySuggestion", true);
    setValue("sameShipNameasKO", false);
    setValue("sameBillNameasKO", false);

    setValue(
      "contractOfficerName",
      `${item?.first_name || ""} ${item?.last_name || ""}`
    );
    setValue(
      "contractOfficerEmail",
      item?.primary_email ? item.primary_email.Address : ""
    );
    setValue(
      "contractOfficerPhone",
      prependCountryCodeIfMissing(item?.primary_phone?.FreeFormNumber || "")
    );
    // setValue(
    //   "contractOfficerPhone",
    //   item?.primary_phone ? item.primary_phone.FreeFormNumber : ""
    // );
    setValue("contractOfficerAddress", item.address);
    setValue("shippingCustomerName", item?.shipping_name);
    setValue("shippingCustomerEmail", item?.shipping_email);
    setValue(
      "shippingCustomerPhone",
      prependCountryCodeIfMissing(item?.shipping_phone || "")
    );
    // setValue("shippingCustomerPhone", item?.shipping_phone);

    if (item?.shipping_address) {
      const address = item.shipping_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "")
        .join("\n");
      setValue("shippingCustomerAddress", formattedAddress);
    }
    setValue("BillingCustomerName", item?.billing_name);
    setValue("BillingCustomerEmail", item?.billing_email);
    setValue(
      "BillingCustomerPhone",
      prependCountryCodeIfMissing(item?.billing_phone || "")
    );
    // setValue("BillingCustomerPhone", item?.billing_phone);

    if (item?.billing_address) {
      const address = item.billing_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "")
        .join("\n");
      setValue("BillingCustomerAddress", formattedAddress);
    }
  };

  const handleBlur = () => {
    setTimeout(() => {
      setSuggestion(null);
    }, 150);
  };

  const handleSearchByName = (e) => {
    setValue("contractOfficerName", e.target.value);
    setSearchDebounce({ searchName: e.target.value });
  };
  const handleSearchByEmail = (e) => {
    setValue("contractOfficerEmail", e.target.value);
    setSearchDebounce({ searchEmail: e.target.value });
  };

  const onSuccessData = (data) => {
    setSuggestion(data);
  };

  const onErorrData = (data) => {
    setSuggestion(null);
  };

  useEffect(() => {
    if (
      searchDebounce?.searchEmail?.length > 0 ||
      searchDebounce?.searchName?.length > 0
    ) {
      fetchRfq(
        {
          email:
            searchDebounce?.searchEmail?.length > 0
              ? searchDebounce?.searchEmail
              : undefined,
          first_name:
            searchDebounce?.searchName?.length > 0
              ? searchDebounce?.searchName
              : undefined,
          module_type: "ORDER",
        },
        onSuccessData,
        onErorrData
      );
    }
  }, [debounceSearch, searchDebounce]);

  useEffect(() => {
    handleResize(textareaRef.current);
  }, [address]);

  useEffect(() => {
    handleResize(textareaRef.current);
  }, [BillingAddress]);

  const WarehouseSelected = watch("Warehouse");

  useEffect(() => {
    if (OrderType == "CRK" || OrderType == "M") {
      setValue("Warehouse", "1");
    } else {
      setValue("Warehouse", "0");
    }
  }, []);

  const CustomInput = ({ value, onClick }) => (
    <input
      className="form-control"
      type="text"
      value={value}
      placeholderText="Select a date"
      onClick={onClick}
      readOnly
      style={{ cursor: "pointer" }}
    />
  );

  return (
    <>
      {/* <Row className="mb-3 mt-3">
        <Form.Group as={Col}>
          <div style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}>
            <Form.Label className="w-md-auto" style={{ fontWeight: "bold" }}>
              Initial Consolidation at Aspetto's Warehouse :
            </Form.Label>
            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="yes"
                value="1"
                {...register("Warehouse")}
              />
              <Form.Check.Label htmlFor="yes">YES</Form.Check.Label>
            </Form.Check>
            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="no"
                value="0"
                {...register("Warehouse")}
              />
              <Form.Check.Label htmlFor="no">NO</Form.Check.Label>
            </Form.Check>
          </div>
        </Form.Group>
      </Row> */}
      <Row className="">
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Estimated Delivery (Days)</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("estimateddelivery")}
                defaultValue={30}
              />
            </InputGroup>
            {errors.estimateddelivery && (
              <span className="text-danger">
                {errors.estimateddelivery.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Payment Terms</Form.Label>
            <InputGroup>
              <Form.Select {...register("payment_terms")}>
                {TERMS.Term.map((item, index) => (
                  <option key={index} value={item.Id}>
                    {item.Name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {errors.payment_terms && (
              <span className="text-danger">
                {errors.payment_terms.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Shipping Method</Form.Label>
            <InputGroup>
              <Form.Select {...register("shipping_method")}>
                <option value={""}>Select a method</option>
                <option value={"UPS"}>UPS</option>
                <option value={"FedEx"}>FedEx</option>
                <option value={"Freight"}>Freight</option>
                <option value={"Other"}>Other</option>
              </Form.Select>
            </InputGroup>
            {errors.shipping_method && (
              <span className="text-danger">
                {errors.shipping_method.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>FOB</Form.Label>
            <InputGroup>
              <Form.Select {...register("shipping_terms")}>
                <option value={""}>Select a terms</option>
                <option value={"FOB Origin"}>FOB Origin</option>
                <option value={"FOB Destination"}>FOB Destination</option>
              </Form.Select>
            </InputGroup>
            {errors.shipping_terms && (
              <span className="text-danger">
                {errors.shipping_terms.message}
              </span>
            )}
          </Form.Group>
        </Col>

        {["10"].includes(watch("payment_terms")) && (
          <Col xs={12}>
            <Form.Group className="mb-3">
              <Form.Label>Payment Term Details</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder={`Enter payment term details`}
                  {...register("payment_term_detail")}
                />
              </InputGroup>
              {errors.payment_term_detail && (
                <span className="text-danger">
                  {errors.payment_term_detail.message}
                </span>
              )}
            </Form.Group>
          </Col>
        )}
        {["Freight", "Other"].includes(watch("shipping_method")) && (
          <Col xs={12}>
            <Form.Group className="mb-3">
              <Form.Label>
                {watch("shipping_method") === "Freight"
                  ? "Shipping Method Freight Details"
                  : "Shipping Method Other Details"}
              </Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder={`Enter ${watch("shipping_method")} details`}
                  {...register("shipping_method_detail")}
                />
              </InputGroup>
              {errors.shipping_method_detail && (
                <span className="text-danger">
                  {errors.shipping_method_detail.message}
                </span>
              )}
            </Form.Group>
          </Col>
        )}
      </Row>
      <Row className="">
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Tracking Number</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("trackingNumber")}
                // defaultValue={30}
                placeholder="Enter Tracking Number"
              />
            </InputGroup>
            {errors.trackingNumber && (
              <span className="text-danger">
                {errors.trackingNumber.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Carrier</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("carrier")}
                placeholder="Enter Carrier"
              />
            </InputGroup>
            {errors.carrier && (
              <span className="text-danger">{errors.carrier.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Purchase Order</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("purchaseOrder")}
                // defaultValue={30}
                placeholder="Enter Purchase Order"
              />
            </InputGroup>
            {errors.purchaseOrder && (
              <span className="text-danger">
                {errors.purchaseOrder.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Delivery Order</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("deliveryOrder")}
                // defaultValue={30}
                placeholder="Enter Delivery Order"
              />
            </InputGroup>
            {errors.deliveryOrder && (
              <span className="text-danger">
                {errors.deliveryOrder.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Amendment</Form.Label>
            <InputGroup>
              <Form.Control
                type="text"
                {...register("amendment")}
                placeholder="Enter Amendment"
              />
            </InputGroup>
            {errors.amendment && (
              <span className="text-danger">{errors.amendment.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label className="">Ship Date</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="shipDate"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value ? new Date(field.value) : null}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    // minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                    customInput={<CustomInput />}
                  />
                )}
              />
            </InputGroup>
            {errors.shipDate && (
              <span className="text-danger">{errors.shipDate.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Shipping Cost</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCurrencyDollar stroke={2} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                onKeyDown={handleKeyDown}
                {...register("shippingCostPacking")}
                placeholder="Enter Shipping Cost"
              />
            </InputGroup>
            {errors.shippingCostPacking && (
              <span className="text-danger">{errors.shippingCostPacking.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>

      <Card className="mb-3 card_suggestion">
        <Card.Header className="card_header">
          <IconFileDescription /> KO (Contracting Officer) Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractOfficerName")}
                    onChange={handleSearchByName}
                    onBlur={handleBlur}
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                <div>
                  {((suggestion?.data?.length > 0 &&
                    searchDebounce?.searchName?.length > 0) ||
                    searchDebounce?.searchEmail?.length > 0) && (
                    <div className="suggestions_box">
                      <div className="table-responsive">
                        <Table>
                          <tbody>
                            {suggestion?.data?.map((item, index) => (
                              <tr
                                key={index}
                                onClick={() => handleSelect(item)}
                                style={{ cursor: "pointer" }}
                              >
                                <td>{item?.display_name}</td>
                                <td>{`${item?.first_name || ""} ${
                                  item?.last_name || ""
                                }`}</td>
                                <td>
                                  {item?.primary_email
                                    ? item.primary_email?.Address
                                    : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}
                </div>
                {errors.contractOfficerName && (
                  <span className="text-danger">
                    {errors.contractOfficerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("contractOfficerEmail")}
                    onBlur={handleBlur}
                    onChange={handleSearchByEmail}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.contractOfficerEmail && (
                  <span className="text-danger">
                    {errors.contractOfficerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="contractOfficerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.contractOfficerPhone && (
                  <span className="text-danger">
                    {errors.contractOfficerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    as="textarea"
                    {...register("contractOfficerAddress")}
                    style={{
                      height: "auto",
                      minHeight: "80px",
                      resize: "none",
                    }}
                    onInput={(e) => {
                      e.target.style.height = "auto"; // Reset height to auto
                      e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                    }}
                    placeholder="Enter Address"
                  />
                </InputGroup>
                {errors.contractOfficerAddress && (
                  <span className="text-danger">
                    {errors.contractOfficerAddress.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-3">
        <Card.Header className="card_header">
          <IconTruck /> Shipping Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("shippingCustomerName")}
                    type="text"
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                {errors.shippingCustomerName && (
                  <span className="text-danger">
                    {errors.shippingCustomerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("shippingCustomerEmail")}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.shippingCustomerEmail && (
                  <span className="text-danger">
                    {errors.shippingCustomerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="shippingCustomerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.shippingCustomerPhone && (
                  <span className="text-danger">
                    {errors.shippingCustomerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>
                  <Controller
                    name="shippingCustomerAddress"
                    control={control}
                    defaultValue={address}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        as="textarea"
                        style={{
                          height: "auto",
                          minHeight: "80px",
                          resize: "none", // Prevent manual resize
                        }}
                        onInput={(e) => {
                          e.target.style.height = "auto"; // Reset height to auto
                          e.target.style.height = `${e.target.scrollHeight}px`; // Set height to scrollHeight to expand
                        }}
                        placeholder="Enter Address"
                      />
                    )}
                  />
                </InputGroup>
                {errors.shippingCustomerAddress && (
                  <span className="text-danger">
                    {errors.shippingCustomerAddress.message}
                  </span>
                )}

                <div className="d-flex gap-3 align-items-center">
                  <Form.Text className="ko_button d-flex gap-2 pt-2">
                    <Form.Check
                      className="ko_fill_link"
                      type="checkbox"
                      id="sameShipNameasKO"
                      label="Fill with KO’s information "
                      {...register("sameShipNameasKO", {
                        onChange: (e) =>
                          handleSameAsKO("shipping", e.target.checked),
                      })}
                    />
                  </Form.Text>
                  <Form.Text className="d-none">
                    <Form.Check
                      className="ko_fill_link"
                      type="checkbox"
                      id="selectedBySuggestion"
                      hidden
                      {...register("selectedBySuggestion")}
                    />
                  </Form.Text>
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-5">
        <Card.Header className="card_header">
          <IconReceipt /> Billing Details
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Full Name</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconUser stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("BillingCustomerName")}
                    placeholder="Enter Full Name"
                  />
                </InputGroup>
                {errors.BillingCustomerName && (
                  <span className="text-danger">
                    {errors.BillingCustomerName.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    {...register("BillingCustomerEmail")}
                    type="email"
                    placeholder="Enter Email"
                  />
                </InputGroup>
                {errors.BillingCustomerEmail && (
                  <span className="text-danger">
                    {errors.BillingCustomerEmail.message}
                  </span>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconPhone stroke={1} />
                  </InputGroup.Text>

                  <Controller
                    name="BillingCustomerPhone"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) =>
                        (value && value.length > 0) || "Invalid phone number",
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        className="form-control"
                        {...field}
                        defaultCountry="US"
                        countryCallingCodeEditable={false}
                        international
                        placeholder="Enter phone number"
                        onChange={field.onChange}
                      />
                    )}
                  />
                </InputGroup>
                {errors.BillingCustomerPhone && (
                  <span className="text-danger">
                    {errors.BillingCustomerPhone.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconHomeSpark stroke={1} />
                  </InputGroup.Text>

                  <Controller
                    name="BillingCustomerAddress"
                    control={control}
                    defaultValue={BillingAddress}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        as="textarea"
                        ref={(e) => {
                          field.ref(e);
                          textareaRef.current = e;
                        }}
                        onInput={handleResize}
                        style={{ resize: "none" }}
                        placeholder="Enter Address"
                      />
                    )}
                  />
                </InputGroup>
                {errors.BillingCustomerAddress && (
                  <span className="text-danger">
                    {errors.BillingCustomerAddress.message}
                  </span>
                )}
                <Form.Text className="ko_button d-flex gap-2 pt-2">
                  <Form.Check
                    className="ko_fill_link"
                    type="checkbox"
                    id="sameBillNameasKO"
                    label="Fill with KO’s information"
                    {...register("sameBillNameasKO", {
                      onChange: (e) =>
                        handleSameAsKO("billing", e.target.checked),
                    })}
                  />
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
}

export default BillingAndShippingForm;
